import { render } from "./PickupDashboard.vue?vue&type=template&id=79fca850&scoped=true"
import script from "./PickupDashboard.vue?vue&type=script&lang=js"
export * from "./PickupDashboard.vue?vue&type=script&lang=js"

import "./PickupDashboard.vue?vue&type=style&index=0&id=79fca850&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79fca850"]])

export default __exports__